import ConsultationsListItem from 'components/consultations/ConsultationsListItem'
import EntitiesList from 'components/entities/EntitiesList';
import { connect } from 'react-redux'
import { getFilteredSortedConsultations } from "selectors/consultations";
import { getPersistedEntities } from "../../selectors/entities";

const mapStateToProps = (state, ownProps) => {
  const employments = getPersistedEntities('employment')(state, ownProps);
  const employmentOptions = employments.map((emp) => {
    return { key: emp.id, value: emp.id, text: emp.name }
  })
  const types = getPersistedEntities('consultationType')(state, ownProps);
  const typeOptions = types.map((type) => {
    return { key: type.id, value: type.id, text: type.name }
  })

  const locations = getPersistedEntities('location')(state, ownProps);
  const locationOptions = locations.map((loc) => {
    return { key: loc.id, value: loc.id, text: loc.name }
  })

  const filters = [
    {by: 'name', getTarget: (consult) => consult.dossier?.patient && consult.dossier.patient.firstName + ' ' + consult.dossier.patient.lastName },
    {by: 'consultation_type', selectOptions: typeOptions, getTarget:(consult) => [consult.consultationTypeId] },
    {by: 'location', selectOptions: locationOptions, getTarget:(consult) => [consult.locationId] },
  ]

  if (state.view === "admin") {
    filters.push({ by: 'employment', selectOptions: employmentOptions, getTarget: (consultation) => [consultation.practionerId]})
  }

  return {
    entities: getFilteredSortedConsultations(ownProps.keyWindow)(state, filters),
    entityName: 'consultation',
    item: ConsultationsListItem,
    loading: state.meta?.consultation?.loading,
    error: state.meta?.consultation?.error,
    filters:filters
  };
}
export default connect(mapStateToProps)(EntitiesList);
